import { Module } from 'vuex';

const key = 'managerProjectsPageFilter';
export interface ProjectsStateStorable {
  filters: { company: string[]; search: string };
}

export const defaultProjectsState: ProjectsStateStorable = {
  filters: {
    company: undefined,
    search: undefined
  }
};

export const projects: Module<ProjectsStateStorable, any> = {
  namespaced: true,
  state: {
    filters: localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : defaultProjectsState.filters
  },
  getters: {
    filters: state => getFiltersFromState(state)
  },
  mutations: {
    setCompanyFilter(state, company: string[]) {
      const filters = getFiltersFromState(state);
      filters.company = company;
      persistFiltersState(state, filters);
    },
    setSearchFilter(state, search: string) {
      const filters = getFiltersFromState(state);
      filters.search = search;
      persistFiltersState(state, filters);
    }
  }
};

const getFiltersFromState = (state): any => {
  return Object.assign({}, state.filters);
};

const persistFiltersState = (state, filters: any) => {
  state.filters = filters;
  localStorage.setItem(key, JSON.stringify(filters));
};
